module.exports = __webpack_public_path__ + "img/c1.5afb27a5.png";